import { createContext, useContext } from 'react';
export const SystemApiWsContext = createContext(null);
export function useSystemApiWsClient() {
    return useContext(SystemApiWsContext);
}
export const SystemApiWsProvider = SystemApiWsContext.Provider;
//# sourceMappingURL=SystemApiWsContext.js.map